/* dev-card-product.js */

if (!window.__devCardProductInit) {
  window.__devCardProductInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.bestsellers__add-to-cart');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const label = btn.querySelector('span');
    if (!label) return;
    const originalText = label.textContent;

    btn.classList.add('bestsellers__add-to-cart--adding');
    label.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {
        label.textContent = 'Added!';
        setTimeout(() => {
          label.textContent = originalText;
          btn.classList.remove('bestsellers__add-to-cart--adding');
        }, 1500);

        const event = new Event('cart:update', { bubbles: true });
        event.detail = {
          resource: cart,
          sourceId: 'dev-card-product',
          data: {
            source: 'dev-card-product',
            itemCount: cart.item_count,
            variantId: variantId
          }
        };
        document.dispatchEvent(event);
      })
      .catch(() => {
        label.textContent = 'Error';
        setTimeout(() => {
          label.textContent = originalText;
          btn.classList.remove('bestsellers__add-to-cart--adding');
        }, 1500);
      });
  });
}
